type CompatibleType<Type> = Type extends Set<infer Entry> ? Array<Entry> : Type;

export const convertToCompatibleType = <Type>(value: Type) =>
    (value instanceof Set ? [...value] : value) as CompatibleType<Type>;
